import type { Object3D, Object3DEventMap } from "three"

export interface GameObject3DEventMap extends Object3DEventMap {
  frame: Readonly<{
    type: "frame",
    // delta time since last frame in ms
    dt: number,
    // frame timestamp
    at: number,
  }>,
  dispose: Readonly<{
    type: "dispose",
  }>,
}

type GameObject3DEventMapKey = keyof GameObject3DEventMap

export function addGameObject3DEventListener<TEventKey extends GameObject3DEventMapKey>(
  obj: Object3D<GameObject3DEventMap>,
  eventName: TEventKey,
  fn: (event: GameObject3DEventMap[TEventKey]) => void
): void {
  obj.addEventListener(eventName, fn)
}

export function removeGameObject3DEventListener<TEventKey extends GameObject3DEventMapKey>(
  obj: Object3D<GameObject3DEventMap>,
  eventName: TEventKey,
  fn: (event: GameObject3DEventMap[TEventKey]) => void
): void {
  obj.removeEventListener(eventName, fn)
}

export function hasGameObject3DEventListener<TEventKey extends GameObject3DEventMapKey>(
  obj: Object3D<GameObject3DEventMap>,
  eventName: TEventKey,
  fn: (event: GameObject3DEventMap[TEventKey]) => void
): void {
  obj.hasEventListener(eventName, fn)
}

type DispatchEventParam1 = Parameters<Object3D['dispatchEvent']>[0]

export function dispatchGameObject3DEventListener(
  obj: Object3D,
  event: GameObject3DEventMap[GameObject3DEventMapKey],
): void {
  obj.dispatchEvent(event as DispatchEventParam1)
}
